// i18n
import { translate } from 'infras/i18n';

import DashboardSettingPageTemplate from 'presentations/views/components/templates/DashboardSettingPageTemplate';
import SubscriptionUpdateList from 'presentations/views/components/organisms/SubscriptionUpdateList';
import { ViewerItem } from 'presentations/api/schema/user';

import ServiceContentBox from 'presentations/views/components/templates/ServiceContentBox';
import IntegrationList from 'presentations/views/components/organisms/IntegrationList';
import { useRouter } from 'next/router';
import IntegrationHeader from 'presentations/views/components/organisms/IntegrationHeader';
import { useIntegrationListPage } from './hooks';
import { useContext } from 'react';
import { DashboardPortalContext } from 'presentations/reducers/DashboardPortal';

interface Props {
  viewer?: ViewerItem;
}

export default function Component(props: Props) {
  const { state: dashboardState } = useContext(DashboardPortalContext);
  const viewer = props.viewer || dashboardState.viewer!;

  const { state, actions } = useIntegrationListPage({ viewer });
  const router = useRouter();
  const texts: string[] = [];
  if (!state.canAddCalendar) {
    texts.push(translate('subscription.plan.calendarCountMax'));
  }
  return (
    <DashboardSettingPageTemplate
      isLoading={state.isLoading}
      viewer={viewer!}
      contentHeader={
        <IntegrationHeader
          currentUrl={router.asPath}
          isShowAdvancedMenu={state.isShowAdvancedMenu}
        />
      }
      content={
        <ServiceContentBox>
          <SubscriptionUpdateList texts={texts} role={viewer.role} />
          <IntegrationList
            viewer={viewer}
            isLogin
            selectedProviderTypes={state.selectedProviderTypes}
            canAddCalendar={state.canAddCalendar}
            shopAccount={state.shopAccount}
            isiOSApp={state.isiOSApp}
            isOpenDialog={state.isOpenDialog}
            onCloseDialog={actions.onCloseDialog}
            checkAdminRole={actions.checkAdminRole}
          />
        </ServiceContentBox>
      }
    />
  );
}
